export interface WaterProduct {
  id: string;
  name: string;
  subtitle: string;
  tagline: string;
  description: string;
  images: string[];
  features: string[];
  highlights: { title: string; value: string; icon: string }[];
  pdfUrl?: string;
  technicalSpecs: Record<string, string>;
  physicalCharacteristics: Record<string, string>;
  accessoryImages?: { accName: string; accImage: string }[];
}

export const waterProducts: WaterProduct[] = [
  {
    id: "rx-log-1.1",
    name: "Rx-Log 1.1",
    subtitle: "Real-Time Water Network Monitor",
    tagline: "Track Every Drop, Prevent Loss!",
    description: `The Realix Rx-Log 1.1 is designed to monitor your water network on a real-time basis and optimize resource usage for better efficiency.

It features Bluetooth connectivity for local connection and configuration, along with a Cellular Modem (4G with 2G fallback) for reliable remote data transmission. With a massive memory capacity capable of storing 3.5 years of history on the primary channel, it ensures no data is lost.`,
    images: [
      "/images/products/water-logger/rx-log-1.1-front.png",
      "/images/products/water-logger/rx-log-1.1-side.png",
    ],
    features: [
      "CONNECTIVITY: Cellular 4G with 2G Fallback & SMS Option",
      "LOCAL CONFIG: BT Connectivity for local connection",
      "INPUTS: Digital, Analogue, Serial inputs",
      "MEMORY: Primary channel - 3.5 years history",
      "ENCLOSURE: ABS Plastic with Metal mounting clamp",
      "TEMP RANGE: -20°C to +60°C (-5°F to +140°F)",
    ],
    highlights: [
      { title: "Network", value: "4G/2G", icon: "ion:wifi" },
      { title: "Memory", value: "3.5 Yrs", icon: "ion:save-outline" },
      { title: "Inputs", value: "Multi", icon: "ion:options-outline" },
      { title: "Temp", value: "60°C", icon: "ion:thermometer-outline" },
    ],
    pdfUrl: "",
    technicalSpecs: {
      "Local Connectivity": "Bluetooth (BT) for configuration",
      "Remote Connectivity": "Cellular Modem 4G (2G Fallback)",
      Backup: "SMS option as fall back",
      "Input Options": "Digital, Analogue, Serial inputs",
      "Memory History": "Primary channel - 3.5 years",
    },
    physicalCharacteristics: {
      "Enclosure Material": "ABS Plastic",
      Mounting: "Metal mounting clamp",
      "Operating Temp": "-20°C to +60°C (-5°F to +140°F)",
    },
    accessoryImages: [],
  },
];
